import React, { useImperativeHandle } from 'react';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import Budget, {
  FeedbackMakeEditsBudgetHandler,
} from '../../../ReportBuilder/Components/Budget';
import {
  DIRECT_COST_QUESTION_ID,
  IN_KIND_DONATIONS_QUESTION_ID,
  OVERHEAD_COST_QUESTION_ID,
} from '../../../ReportBuilder/Components/Budget/utils';
import { FeedbackQuestionsById } from '../api';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledDiv = styled.div`
  .file-upload-box {
    textarea {
      border-radius: ${SPACERS.extraTiny};
      border: 1px solid ${COLORS.grayBase};
      background-color: ${COLORS.whiteBase};
    }
  }
`;

const budgetQuestions = [
  DIRECT_COST_QUESTION_ID,
  IN_KIND_DONATIONS_QUESTION_ID,
  OVERHEAD_COST_QUESTION_ID,
];
const noOp = () => null;

const getAnswers = (questions: FeedbackQuestionsById) => {
  const result: { [id: number]: string | undefined } = {};
  for (const questionId of budgetQuestions) {
    const q = questions[questionId];
    if (q) {
      result[questionId] = q.answers[0]?.text;
    }
  }
  return result;
};

const BudgetSection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(
  (
    {
      reportId,
      questionId,
      answer,
      questions,
      questionText,
      programName,
      guidanceText,
      isReportPassed,
      feedbackByQuestionId,
    },
    forwardRef,
  ) => {
    const ref = React.useRef<FeedbackMakeEditsBudgetHandler>(null);

    useImperativeHandle(forwardRef, () => ({
      reportId,
      questionId,
      answer: () => ref.current?.handleSubmit() || '',
      errorText: () => ref.current?.error(),
    }));

    return (
      <StyledDiv>
        <Budget
          handleBack={noOp}
          handleNext={noOp}
          onNextSection={noOp}
          onPreviousSection={noOp}
          handleValueChange={noOp}
          hideBottomBar={true}
          allValues={getAnswers(questions)}
          programName={programName}
          reportId={reportId}
          value={answer}
          isReportPassed={isReportPassed}
          questionRef={ref}
          guidanceText={guidanceText}
          feedbackByQuestionId={feedbackByQuestionId}
          question={{
            autoSave: false,
            dbId: questionId,
            enumPrograms: [],
            enumResponses: [],
            feExtraRequirement: null,
            helpContent: null,
            id: questionId,
            nextQuestionId: null,
            questionType: 'RADIO',
            section: 'budget',
            sectionStart: false,
            tab: null,
            text: questionText,
            text_html: questionText,
            validations: [],
          }}
        />
      </StyledDiv>
    );
  },
);

export default BudgetSection;
